const imgPath = "/images/fallback_image.png"

function applyFallback(img) {
  img.onerror = null
  img.removeAttribute("srcset")
  img.src = imgPath
}

function setFallbackImage(img) {
  // If image already failed before hook mounted, naturalWidth will be 0
  if (!img.src || (img.complete && img.naturalWidth === 0)) {
    applyFallback(img)
    return
  }

  img.onerror = function () {
    applyFallback(img)
  }
}

const ImageFallback = {
  mounted() {
    setFallbackImage(this.el)
  },
  updated() {
    setFallbackImage(this.el)
  },
}

export { ImageFallback }
